import {brand, Branded, TypeOf} from 'io-ts';
import {DoubleString} from './DoubleString';

interface NonNegativeDoubleStringBrand {
    readonly NonNegativeDoubleString: unique symbol;
}

export const NonNegativeDoubleString = brand(
    DoubleString,
    (n): n is Branded<DoubleString, NonNegativeDoubleStringBrand> => parseFloat(n) >= 0,
    'NonNegativeDoubleString'
);

export type NonNegativeDoubleString = TypeOf<typeof NonNegativeDoubleString>;
